var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-sm":"","text-xs-left":"","mt-4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-left":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('SynonymsTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }